import React from "react";
import StarSvg from "../../assets/taiga-uikit/icons/star.svg?react";
import "./Star.css";

interface StarProps {
  active?: boolean;
  number: number;
  handleClick?: (number: number) => void;
  handleMouseEnter?: (number: number) => void;
  handleMouseLeave?: (number: number) => void;
}

export const Star: React.FC<StarProps> = ({
  active = false,
  number,
  handleClick = null,
  handleMouseEnter = null,
  handleMouseLeave = null,
  ...props
}) => {
  return (
    <div
      className={active ? "star star-active" : "star"}
      onMouseEnter={() => handleMouseEnter && handleMouseEnter(number)}
      onMouseLeave={() => handleMouseLeave && handleMouseLeave(number)}
      onClick={() => handleClick && handleClick(number)}
      {...props}
    >
      <StarSvg />
    </div>
  );
};
